import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { integrationSchemaRegistry } from '@main/shared/utils';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { MicrosoftDefenderService } from '../../service';

export type ListSecurityAlertsConfig = typeof ListSecurityAlertsConfig._.Config;

export enum AzureAlertSeverity {
  High = 'High',
  Medium = 'Medium',
  Low = 'Low',
  Informational = 'Informational',
}

export const ListSecurityAlertsConfig = IntegrationConfig.make({
  service: MicrosoftDefenderService,
  name: Integration_Handler_Names_Enum.ListSecurityAlerts,
  configSchema: z.object({
    severities: z
      .array(
        z.enum(AzureAlertSeverity).register(integrationSchemaRegistry, {
          i18n: 'integrations.azure.services.microsoft_defender.shared.azure_alert_severity',
        }),
      )
      .optional(),
    resourceGroups: z.array(z.string().min(1)).optional(),
    affectedResources: z.array(z.string().min(1)).optional(),
  }),
});
